export const AssignStaffHeader = ({ name, role, hideSubtitle }: AssignStaffHeaderProps): JSX.Element => {
    return (
        <div>
            <div className="has-text-weight-semibold is-size-7">{name}</div>
            <div className="has-text-weight-bold my-1">{`Assign ${role} Role`}</div>
            {!hideSubtitle && (
                <div className="is-size-7">User works closely with examinees and sets them up to take their test</div>
            )}
        </div>
    );
};

interface AssignStaffHeaderProps {
    name?: string;
    role?: string;
    hideSubtitle?: boolean;
}
